import { render, staticRenderFns } from "./functionalArea.vue?vue&type=template&id=25458d09&scoped=true&"
import script from "./functionalArea.vue?vue&type=script&lang=js&"
export * from "./functionalArea.vue?vue&type=script&lang=js&"
import style0 from "./functionalArea.vue?vue&type=style&index=0&id=25458d09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25458d09",
  null
  
)

export default component.exports